import { NgControl } from '@angular/forms';
import {
  Optional,
  Host,
  ComponentRef,
  ViewContainerRef,
  ComponentFactoryResolver,
  Directive,
  OnInit,
  OnDestroy,
  Self,
  ElementRef
} from '@angular/core';
import { Observable, EMPTY, Subscription, fromEvent } from 'rxjs';
import { FormSubmitDirective } from './form-submit.directive';
import { ControlErrorComponent } from '../components/error-container/control-error.component';
import { merge } from 'rxjs';
import { defaultErrors } from '../models/errors';
import { ControlErrorContainerDirective } from './control-error-container.directive';



@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[showControlErrors]'
})
export class ControlErrorsDirective implements OnInit, OnDestroy {

  private subscriptions: Subscription[] = [];
  private ref: ComponentRef<ControlErrorComponent>;
  private submit$: Observable<Event>;
  private blur$: Observable<Event>;
  container: ViewContainerRef;

  constructor(
    private vcr: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
    elementRef: ElementRef,
    @Self() private control: NgControl,
    @Optional() @Host() private form: FormSubmitDirective,
    @Optional() controlErrorContainer: ControlErrorContainerDirective,

    // @Optional() @Host() private errorsDirective: ControlErrorsDirective[],
  ) {

    this.submit$ = this.form ? this.form.submit$ : EMPTY;
    this.blur$ = elementRef.nativeElement ? fromEvent(elementRef.nativeElement, 'blur') : EMPTY;
    this.container = controlErrorContainer ? controlErrorContainer.vcr : vcr;
  }

  private buildErrorsSingleComponent(): void {
    const controlErrors = this.control.errors;
    if (controlErrors && this.control.enabled && this.control.touched) {
      const errorsArray: string[] = [];
      for (const errKey of Object.keys(controlErrors)) {
        const getError = defaultErrors[errKey];
        const errorText = getError ? getError(controlErrors[errKey]) : 'Campo Inválido';
        errorsArray.push(errorText);
      }
      this.setError(errorsArray);
    } else if (this.ref) {
      this.setError([]);
    }
  }

  private buildErrorsAllComponents(): void {
    const controlErrors = this.control.errors;
    if (controlErrors && this.control.enabled) {
      const errorsArray: string[] = [];
      for (const errKey of Object.keys(controlErrors)) {
        const getError = defaultErrors[errKey];
        const errorText = getError ? getError(controlErrors[errKey]) : 'Campo Inválido';
        errorsArray.push(errorText);
      }
      this.setError(errorsArray);
    } else if (this.ref) {
      this.setError([]);
    }
  }

  setError(errors: string[]) {
    if (!this.ref) {
      const factory = this.resolver.resolveComponentFactory(ControlErrorComponent);
      this.ref = this.container.createComponent(factory);
    }

    this.ref.instance.errors = errors;
  }

  ngOnInit() {
    const sub1 = merge(
      this.blur$,
      this.control.valueChanges
    ).subscribe({
      next: (a: any) => {
        this.buildErrorsSingleComponent.bind(this)(a);
      }
    });

    const sub2 = this.submit$.subscribe({
      next: (a) => {
        this.buildErrorsAllComponents.bind(this)(a);
      }
    });

    this.subscriptions.push(sub1, sub2);

  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => {
      if (s) {
        s.unsubscribe();
      }
    });
  }

}
